export const DEFAULT_SQLITE_CACHE_PATH = '.mercato/cache/cache.db'
export const DEFAULT_JSON_FILE_CACHE_PATH = '.mercato/cache/cache.json'
